/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import GradesIcon from 'icons/GradesIcon';

const messages = defineMessages({
  title: {id: 'navigation.standards-grades'},
});

const StandardsGradesItem = () => (
  <StudentRouteLinkItem
    iconBefore={GradesIcon}
    route="midas/student/standards-grades"
    title={messages.title}
  />
);

export default StandardsGradesItem;
